import React, { useState, useEffect } from "react";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { Link, useParams } from "react-router-dom";
import Axios from "../../axios/axios";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import { toTitleCase } from "../../components/utils/StringUtil";
import { toast } from "react-toastify";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Modal } from "bootstrap";
import ConformModal from "../../actions/ConformModal";
import AlertModal from "../../actions/AlertModal";

export default function OrderDetails() {
  const { id } = useParams();
  const [orderDetails, setOrderDetails] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [note, setNote] = useState("");
  const [loadingId, setLoadingId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [rejectReasons, setRejectReasons] = useState([]);
  const [otherReason, setOtherReason] = useState("");

  const predefinedReasons = ["Price issue", "Quality issue", "Response delay"];

  useEffect(() => {
    if (id) fetchOrderDetails();
    else setLoading(false);
  }, [id]);

  const fetchOrderDetails = async () => {
    try {
      const response = await Axios.get(`/order/get/${id}`);
      setOrderDetails(response.data);

      const customerResponse = await Axios.get(
        `/customer/get/${response.data.customerId}`
      );
      setCustomer(customerResponse.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching order or customer details:", error);
      setLoading(false);
    }
  };

  if (loading) return <p>Loading order details...</p>;
  if (!orderDetails) return <p>Order not found.</p>;

  const openModal = (orderId) => {
    setSelectedOrderId(orderId);
    setNote("");
    const modal = new Modal(document.getElementById("reviewModal")); // ✅ Use imported Modal class
    modal.show();
  };

  const handleModalConfirm = async () => {
    setLoadingId(selectedOrderId);
    try {
      const updateData = {};
      if (note.trim() !== "") updateData.note = note;

      if (Object.keys(updateData).length > 0) {
        await Axios.put(`/order/update/${id}`, updateData);
      }

      // ✅ This PATCH call handles both: status update + balance update
      await Axios.patch(`/orders/${id}/approve-and-update-balance`);

      await fetchOrderDetails();
      setAlertMessage("Order approved and balance updated!");
      setIsAlertOpen(true);

      const modalElement = document.getElementById("reviewModal");
      if (modalElement) {
        const modalInstance = Modal.getOrCreateInstance(modalElement);
        modalInstance.hide();
      }
    } catch (error) {
      console.error("Error confirming order and updating balance:", error);
      setAlertMessage("Failed to approve order.");
      setIsAlertOpen(true);
    } finally {
      setLoadingId(null);
    }
  };

  const handleReviewClick = async () => {
    setLoadingId(selectedOrderId);
    try {
      const updateData = {};
      if (note.trim() !== "") updateData.note = note;

      if (Object.keys(updateData).length > 0) {
        await Axios.put(`/order/update/${id}`, updateData);
      }

      await Axios.put(`/order/changestatus/${id}`, {
        newStatus: "quotation review",
      });
      await fetchOrderDetails();

      setAlertMessage("Review sent, The admin will contact you soon");
      setIsAlertOpen(true);

      const modalElement = document.getElementById("reviewModal");
      if (modalElement) {
        const modalInstance = Modal.getOrCreateInstance(modalElement); // ✅ Close modal
        modalInstance.hide();
      }
    } catch (error) {
      toast.error("Failed to update order.");
      setAlertMessage('Failed to update order status to "Quotaion Review".');
      setIsAlertOpen(true);
    } finally {
      setLoadingId(null);
    }
  };
  const calculateSubtotal = () => {
    if (!orderDetails?.orderItems) return 0;

    return orderDetails.orderItems.reduce((sum, item) => {
      if (orderDetails.businessType?.includes("Rental")) {
        // Multiply by rental days for rentals
        return (
          sum +
          (item.unitPriceWithCommission * item.rentalDays * item.quantity || 0)
        );
      }
      // Non-rental as usual
      return sum + (item.unitPriceWithCommission * item.quantity || 0);
    }, 0);
  };
  const calculateCustomerTotal = () => {
    const subtotal = calculateSubtotal();
    const tax = parseFloat(orderDetails?.taxAmount) || 0;
    return subtotal + tax;
  };

  const toggleReason = (reason) => {
    if (rejectReasons.includes(reason)) {
      setRejectReasons(rejectReasons.filter((r) => r !== reason));
    } else {
      setRejectReasons([...rejectReasons, reason]);
    }
  };

  const handleRejectSubmit = async () => {
    const reasonNote = [...rejectReasons, otherReason.trim()]
      .filter(Boolean)
      .join(", ");
    try {
      await Axios.put(`/order/update/${id}`, { note: reasonNote });
      await Axios.put(`/order/changestatus/${id}`, {
        newStatus: "quotation rejected",
      });

      await Axios.post("/send-rejection-email", {
        orderId: id,
        note: reasonNote,
        customerEmail: customer?.email,
        customerName: customer?.customerName,
      });

      toast.success("Order rejected");
      setIsRejectModalOpen(false);
      await fetchOrderDetails();
    } catch (error) {
      toast.error("Failed to reject order");
    }
  };

  return (
    <div>
      <Header />
      <br />
      <br />
      <br />
      <section id="inner-banner" className="purchaseHistory">
        <div className="container">
          <div className="mt-3 result-select">
            <div className="col-lg-12" style={{ marginTop: "130px" }}>
              <p className="movePages">
                <img src="/images/backIcon.svg" />
                <Link to="/account" className="account">
                  Account
                </Link>
                <Link to="/orderlist" className="account">
                  Orders
                </Link>
                <a href="#">Order details</a>
              </p>

              <div className="row no-gutters purchaseHisOptions">
                <div className="col-lg-6">
                  <h4 className="text-uppercase">Order details</h4>
                </div>
              </div>

              <section className="purchaseContent">
                <div className="historyHeading">
                  <div className="row align-items-center">
                    {/* Left side (Order date + number) */}
                    <div className="col-md-8">
                      <p className="orderDate">
                        Ordered on{" "}
                        {new Date(orderDetails.orderDate).toLocaleDateString()}
                      </p>
                      <p className="orderNumber">
                        Order Number: <b>{orderDetails.orderNumber}</b>
                      </p>
                    </div>

                    {/* Right side (buttons aligned to top right) */}
                    <div className="col-md-4 d-flex justify-content-end gap-2">
                      {orderDetails.orderStatus === "quotation given" ||
                      orderDetails.orderStatus === "quotation review" ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-primary taxInvoiceBtn"
                            onClick={() => openModal(orderDetails._id)}
                          >
                            <span>Review</span>
                          </button>

                          <a
                            href="#"
                            className="btn btn-primary taxInvoiceBtn"
                            data-toggle="modal"
                            data-target="#exampleModalCenter"
                            onClick={(e) => {
                              e.preventDefault();
                              setIsModalOpen(true);
                            }}
                            style={{ textDecoration: "none" }}
                          >
                            <span>Confirm</span>
                          </a>

                          {orderDetails.orderStatus === "quotation given" && (
                            <button
                              className="btn btn-primary btn-danger taxInvoiceBtn"
                              onClick={() => setIsRejectModalOpen(true)}
                            >
                              Reject
                            </button>
                          )}
                        </>
                      ) : orderDetails.orderStatus === "quotation approved" ? (
                        <button
                          type="button"
                          className="btn btn-success"
                          disabled
                          style={{ cursor: "default" }}
                        >
                          <span>Approved</span>
                        </button>
                      ) : orderDetails.orderStatus === "quotation rejected" ? (
                        <button
                          type="button"
                          className="btn btn-primary btn-danger"
                          disabled
                          style={{ cursor: "default" }}
                        >
                          <span>Rejected</span>
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* Modal */}
                <div
                  className="modal fade"
                  id="reviewModal"
                  tabIndex="-1"
                  aria-labelledby="reviewModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="reviewModalLabel">
                          Review Order
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div className="mb-3">
                          <label className="form-label">Note</label>
                          <textarea
                            className="form-control"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            placeholder="Enter note"
                            rows={5}
                          ></textarea>
                        </div>
                      </div>

                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleReviewClick}
                          disabled={loadingId === selectedOrderId}
                        >
                          {loadingId === selectedOrderId
                            ? "Processing..."
                            : "Request For Review"}
                        </button>
                        {/* 
                        {orderDetails.orderStatus !== "quotation approved" && (
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleModalConfirm}
                            disabled={loadingId === selectedOrderId}
                          >
                            {loadingId === selectedOrderId ? "Processing..." : "Confirm"}
                          </button>
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="historyContent">
                  <div className="row">
                    <div className="col-md-6">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">Items</th>
                            <th scope="col">Qty</th>
                            <th scope="col">Price</th>
                            <th scope="col">Total Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderDetails.orderItems.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {toTitleCase(item.productName)}
                                {orderDetails.businessType?.includes(
                                  "Rental"
                                ) && (
                                  <div
                                    style={{ fontSize: "12px", color: "#555" }}
                                  >
                                    <div>
                                      <strong>Rental Period:</strong>{" "}
                                      {new Date(
                                        item.rentStartDate
                                      ).toLocaleDateString()}{" "}
                                      -{" "}
                                      {new Date(
                                        item.rentEndDate
                                      ).toLocaleDateString()}
                                    </div>
                                    <div>
                                      <strong>No. of Days:</strong>{" "}
                                      {item.rentalDays}
                                    </div>
                                  </div>
                                )}
                              </td>

                              <td> {item.quantity}</td>
                              {orderDetails.orderStatus !==
                              "quotation requested" ? (
                                <>
                                  {orderDetails.businessType?.includes(
                                    "Rental"
                                  ) ? (
                                    <>
                                      <td>
                                        AED{" "}
                                        {item.unitPriceWithCommission.toFixed(
                                          2
                                        )}{" "}
                                        / day
                                      </td>
                                      <td>
                                        AED{" "}
                                        <b>
                                          {(
                                            item.unitPriceWithCommission *
                                            item.rentalDays *
                                            item.quantity
                                          ).toFixed(2)}
                                        </b>
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td>
                                        UnitPrice: AED{" "}
                                        {item.unitPriceWithCommission.toFixed(
                                          2
                                        )}
                                      </td>
                                      <td>
                                        AED{" "}
                                        <b>
                                          {(
                                            item.quantity *
                                            item.unitPriceWithCommission
                                          ).toFixed(2)}
                                        </b>
                                      </td>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <td>-</td>
                                  <td>-</td>
                                </>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {orderDetails.orderStatus !== "quotation requested" && (
                      <div className="col-md-5 orderSummary">
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">Order Summary</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Sub total</td>

                              <td>{orderDetails.orderItems.length} Items </td>
                              {/* <td>
                                AED <b>{orderDetails.orderItems.unitPrice}</b>
                              </td> */}
                              <td>
                                AED <b>{calculateSubtotal().toFixed(2)}</b>
                              </td>
                            </tr>
                            <tr>
                              <td>Delivery charge</td>
                              <td> </td>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td>Vat</td>
                              <td></td>
                              <td>5%</td>
                            </tr>
                            <tr>
                              <td>Total</td>
                              <td> </td>
                              {/* <td>
                                AED{' '}
                                <b>
                                  {parseFloat(orderDetails.netAmount) +
                                    parseFloat(
                                      (orderDetails.netAmount * 0.05)?.toFixed(2)
                                    )}
                                </b>
                              </td> */}

                              <td>
                                AED{" "}
                                <b>
                                  {orderDetails?.customerTotal?.toFixed(2) ||
                                    "0.00"}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>

                  <div className="col-md-8">
                    {orderDetails.note && (
                      <div className="mb-3">
                        <h6>Note</h6>
                        <p>{orderDetails.note}</p>
                      </div>
                    )}
                  </div>

                  <div className="col-md-8 deliveryAddress">
                    <div className="row">
                      <div className="col-md-8">
                        <h6>Delivery Address</h6>
                        {customer?.address ? (
                          <>
                            {toTitleCase(customer.address)}
                            <br />
                          </>
                        ) : (
                          <p>No delivery address provided.</p>
                        )}
                      </div>
                      <div className="col-md-4">
                        <h6>Mode of Payment</h6>
                        <p>{toTitleCase(orderDetails.paymentStatus)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      {/* <Footer /> */}
      <ConformModal
        isOpen={isModalOpen}
        message="Are you sure you want to confirm this quotation?"
        onConfirm={() => {
          handleModalConfirm(); // Your logic for confirming
          setIsModalOpen(false);
        }}
        onCancel={() => setIsModalOpen(false)}
      />
      <AlertModal
        isOpen={isAlertOpen}
        message={alertMessage}
        onClose={() => setIsAlertOpen(false)}
      />

      {isRejectModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reject Quotation</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setIsRejectModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Select reasons for rejection:</p>
                {predefinedReasons.map((reason) => (
                  <div className="form-check" key={reason}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={rejectReasons.includes(reason)}
                      onChange={() => toggleReason(reason)}
                      id={reason}
                    />
                    <label className="form-check-label" htmlFor={reason}>
                      {reason}
                    </label>
                  </div>
                ))}
                <div className="mt-3">
                  <label htmlFor="otherReason" className="form-label">
                    Other Reasons:
                  </label>
                  <textarea
                    id="otherReason"
                    className="form-control"
                    rows="3"
                    value={otherReason}
                    onChange={(e) => setOtherReason(e.target.value)}
                    placeholder="Write other reasons..."
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setIsRejectModalOpen(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={handleRejectSubmit}>
                  Submit Rejection
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
